export default __webpack_public_path__ + "static/media/2025_D4URC_Dealer_Portal_Forgot_Password_Page_66836.96fbf5f5.png";